import { render } from "./RpmCheckboxInput.vue?vue&type=template&id=37dfe970"
import script from "./RpmCheckboxInput.vue?vue&type=script&lang=js"
export * from "./RpmCheckboxInput.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__